import React from "react";

export default ({
  label,
  id,
  placeholder,
  value,
  error,
  type,
  className,
  onInputChange,
  rightIcon,
}) => (
  <div className={`form-group ${className || ""} ${error ? "error" : ""}`}>
    {label && (
      <label htmlFor={id} className="t4 text-uppercase">
        {label}
      </label>
    )}

    <div className="input-wrapper">
      <input
        type={type}
        className="form-control"
        id={id}
        placeholder={placeholder}
        value={value}
        onChange={onInputChange}
      />

      {rightIcon && (
        <button
          type="button"
          className="input-eye"
          onClick={rightIcon.onClick}
          aria-label={rightIcon.ariaLabel}
        >
          <i className={`fa ${rightIcon.icon}`} />
        </button>
      )}
    </div>

    {error && <span className="form-text text-error">{error}</span>}
  </div>
);
